/* =========================================================
   ZEUS PRECOMMANDE -- Container 02 landing
   Vanilla JS, IIFE-scoped, namespace data-zeus-pg-*
   Handles: countdown, reserve modal, specs modal, reserved counter
   No AJAX V1: cart-add uses standard product-form POST.
   ========================================================= */
(function () {
  "use strict";

  if (typeof window === "undefined" || !document) return;

  var root = document.querySelector("[data-zeus-pg-root][data-zeus-pg-grid]");
  if (!root) return;

  // A Theme Editor re-render executes this section asset again. Tear down the
  // previous instance before binding the replacement DOM.
  if (window.__zeusPrecommandeCleanup) window.__zeusPrecommandeCleanup();
  var cleanups = [];

  function on(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    cleanups.push(function () {
      target.removeEventListener(type, handler, options);
    });
  }

  function every(handler, delay) {
    var intervalId = window.setInterval(handler, delay);
    cleanups.push(function () {
      window.clearInterval(intervalId);
    });
  }

  window.__zeusPrecommandeCleanup = function () {
    cleanups.splice(0).forEach(function (cleanup) {
      cleanup();
    });
    window.__zeusPrecommandeCleanup = null;
  };

  /* ========================================================= */
  /* HELPERS                                                   */
  /* ========================================================= */
  function clearChildren(el) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  /* Mobile gamme rail: follow reading without moving the document scroll. */
  function initSectionNav() {
    var nav = root.querySelector(".zeus-pg-section-nav");
    if (!nav) return;
    var items = Array.from(nav.querySelectorAll('a[href^="#"]'))
      .map(function (link) {
        return { link: link, section: document.getElementById(link.hash.slice(1)) };
      })
      .filter(function (item) {
        return item.section && root.contains(item.section);
      });
    if (!items.length) return;

    var mobile = window.matchMedia("(max-width: 699px)");
    var active = null;
    var frame = null;

    function update() {
      frame = null;
      if (!mobile.matches) {
        items.forEach(function (item) {
          item.link.removeAttribute("aria-current");
        });
        active = null;
        return;
      }

      // Include Impact's 20px document anchor gap plus the rail's 8px margin.
      var threshold = nav.getBoundingClientRect().bottom + 32;
      var current = items[0];
      items.forEach(function (item) {
        if (item.section.getBoundingClientRect().top <= threshold) current = item;
      });
      if (current === active) return;
      active = current;
      items.forEach(function (item) {
        if (item === current) item.link.setAttribute("aria-current", "location");
        else item.link.removeAttribute("aria-current");
      });

      var rail = nav.getBoundingClientRect();
      var chip = current.link.getBoundingClientRect();
      if (chip.left < rail.left + 8) nav.scrollLeft += chip.left - rail.left - 8;
      else if (chip.right > rail.right - 8) nav.scrollLeft += chip.right - rail.right + 8;
    }

    function schedule() {
      if (frame === null) frame = window.requestAnimationFrame(update);
    }
    on(window, "scroll", schedule, { passive: true });
    on(window, "resize", schedule);
    on(mobile, "change", schedule);
    cleanups.push(function () {
      if (frame !== null) window.cancelAnimationFrame(frame);
      items.forEach(function (item) {
        item.link.removeAttribute("aria-current");
      });
    });
    update();
  }

  /* ========================================================= */
  /* COUNTDOWN -- ticks every second, hides on expiry         */
  /* ========================================================= */
  function initCountdown() {
    var cd = document.querySelector("[data-zeus-pg-countdown]");
    if (!cd) return;

    var rawDeadline = cd.getAttribute("data-deadline");
    if (!rawDeadline) return;

    var deadlineMs = new Date(rawDeadline).getTime();
    if (isNaN(deadlineMs)) return;

    var bandTime = document.querySelector("[data-zeus-pg-urgency-time]");
    var band = document.querySelector("[data-zeus-pg-urgency-band]");
    var elD = cd.querySelector('[data-cd="d"]');
    var elH = cd.querySelector('[data-cd="h"]');
    var elM = cd.querySelector('[data-cd="m"]');
    var elS = cd.querySelector('[data-cd="s"]');

    function pad(n) {
      return String(n).padStart(2, "0");
    }

    function tick() {
      var diff = deadlineMs - Date.now();
      if (diff <= 0) {
        cd.setAttribute("data-closed", "1");
        if (band) band.style.display = "none";
        return false;
      }
      var days = Math.floor(diff / 86400000);
      diff -= days * 86400000;
      var hours = Math.floor(diff / 3600000);
      diff -= hours * 3600000;
      var mins = Math.floor(diff / 60000);
      diff -= mins * 60000;
      var secs = Math.floor(diff / 1000);
      if (elD) elD.textContent = pad(days);
      if (elH) elH.textContent = pad(hours);
      if (elM) elM.textContent = pad(mins);
      if (elS) elS.textContent = pad(secs);
      if (bandTime) {
        var unitD = cd.getAttribute("data-unit-days") || root.getAttribute("data-unit-days") || "j";
        var unitH = cd.getAttribute("data-unit-hours") || root.getAttribute("data-unit-hours") || "h";
        var unitM = cd.getAttribute("data-unit-mins") || root.getAttribute("data-unit-mins") || "m";
        bandTime.textContent = days + unitD + " " + pad(hours) + unitH + " " + pad(mins) + unitM;
      }
      return true;
    }

    if (!tick()) return;
    every(tick, 1000);
  }

  /* ========================================================= */
  /* RESERVED COUNTER + PROGRESS BAR (static admin-set)       */
  /* Auto-increment loop removed 2026-05-28 for L121-2        */
  /* compliance. Counter reflects admin-set value only.       */
  /* ========================================================= */
  function initReservedCounter() {
    var pcount = document.querySelector("[data-zeus-pg-pcount]");
    var pfill = document.querySelector("[data-zeus-pg-pfill]");
    if (!pcount || !pfill) return;

    var current = parseInt(pcount.textContent, 10) || 0;
    var max = parseInt(pfill.getAttribute("data-max"), 10) || 120;
    var pct = Math.min(100, Math.round((current / max) * 100));
    pfill.style.width = pct + "%";
  }

  /* ========================================================= */
  /* MODAL HELPERS                                             */
  /* ========================================================= */
  var lastFocus = null;

  function openDialog(dialog) {
    if (!dialog) return;
    if (dialog.open) return;
    lastFocus = document.activeElement;
    if (typeof dialog.showModal === "function") {
      dialog.showModal();
    } else {
      dialog.setAttribute("open", "");
    }
    document.body.setAttribute("data-zeus-pg-modal-open", "true");
    setTimeout(function () {
      var focusable =
        dialog.querySelector("[autofocus]") ||
        dialog.querySelector('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (focusable) focusable.focus();
    }, 50);
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === "function") {
      dialog.close();
    } else {
      dialog.removeAttribute("open");
    }
    document.body.removeAttribute("data-zeus-pg-modal-open");
    if (lastFocus && typeof lastFocus.focus === "function") {
      lastFocus.focus();
    }
  }

  /* ========================================================= */
  /* RESERVE MODAL -- hydrated on click                       */
  /* ========================================================= */
  function initReserveModal() {
    var dialog = root.querySelector("[data-zeus-pg-reserve-modal]");
    if (!dialog) return;

    var titleEl = dialog.querySelector("[data-zeus-pg-rm-title]");
    var tagEl = dialog.querySelector("[data-zeus-pg-rm-tag]");
    var variantsEl = dialog.querySelector("[data-zeus-pg-rm-variants]");
    var formEl = dialog.querySelector("[data-zeus-pg-rm-form]");
    var formIdEl = dialog.querySelector("[data-zeus-pg-rm-form-id]");
    var totalEl = dialog.querySelector("[data-zeus-pg-rm-total]");
    var submitEl = dialog.querySelector("[data-zeus-pg-rm-submit]");
    var deliveryEl = dialog.querySelector("[data-zeus-pg-rm-delivery]");
    var closeBtn = dialog.querySelector("[data-zeus-pg-modal-close]");

    // Back in stock mode: no cart form, variant picker feeds the <back-in-stock>
    // Klaviyo subscription element instead.
    var bisMode = root.hasAttribute("data-bis-mode");
    var bisEl = dialog.querySelector("back-in-stock");

    function setBisVariant(id) {
      if (bisEl) bisEl.setAttribute("data-bis-variant-id", String(id));
    }

    // Auto-discount applied at checkout. Mirror it in modal preview pricing.
    var discountPct = parseInt(dialog.getAttribute("data-discount-pct"), 10);
    if (isNaN(discountPct) || discountPct < 0 || discountPct > 100) discountPct = 0;
    var discountFactor = (100 - discountPct) / 100;

    function formatPrice(cents) {
      var euros = (cents / 100).toFixed(2).replace(".", ",");
      return euros + " EUR";
    }

    function discountedCents(cents) {
      return Math.round(cents * discountFactor);
    }

    function buildVariantRow(v, idx) {
      var label = document.createElement("label");
      label.className = "zeus-pg-modal-variant";
      if (!v.available && !bisMode) label.setAttribute("data-soldout", "1");

      var input = document.createElement("input");
      input.type = "radio";
      input.name = "zeus_pg_variant";
      input.value = String(v.id);
      if (idx === 0 && (v.available || bisMode)) input.checked = true;
      input.addEventListener("change", function () {
        if (bisMode) {
          setBisVariant(v.id);
          return;
        }
        if (formIdEl) formIdEl.value = String(v.id);
        if (totalEl) totalEl.textContent = formatPrice(discountedCents(v.price));
        if (submitEl) submitEl.disabled = !v.available;
      });

      var titleSpan = document.createElement("span");
      titleSpan.className = "zeus-pg-variant-title";
      titleSpan.textContent = v.title;

      var priceSpan = document.createElement("span");
      priceSpan.className = "zeus-pg-variant-price";
      if (discountPct > 0) {
        var strike = document.createElement("s");
        strike.className = "zeus-pg-variant-strike";
        strike.textContent = formatPrice(v.price);
        var discounted = document.createElement("strong");
        discounted.className = "zeus-pg-variant-discounted";
        discounted.textContent = formatPrice(discountedCents(v.price));
        priceSpan.appendChild(strike);
        priceSpan.appendChild(document.createTextNode(" "));
        priceSpan.appendChild(discounted);
      } else {
        priceSpan.textContent = formatPrice(v.price);
      }

      label.appendChild(input);
      label.appendChild(titleSpan);
      label.appendChild(priceSpan);
      return label;
    }

    function hydrate(card) {
      var title = card.getAttribute("data-product-title") || "";
      var tag = card.getAttribute("data-product-tag") || "";
      var delivery = card.getAttribute("data-delivery-container") || "";
      var rawVariants = card.getAttribute("data-product-variants") || "[]";
      var variants = [];
      try {
        variants = JSON.parse(rawVariants);
      } catch (e) {
        variants = [];
      }

      if (titleEl) titleEl.textContent = title;
      if (tagEl) tagEl.textContent = tag;
      if (deliveryEl && delivery) deliveryEl.textContent = delivery.toLowerCase();
      if (formIdEl && variants.length) formIdEl.value = String(variants[0].id);

      // Single default-title variant : no real size choice, hide the redundant picker row.
      var singleDefault = variants.length === 1 && variants[0].title === "Default Title";
      clearChildren(variantsEl);
      if (variantsEl) {
        if (singleDefault) {
          variantsEl.hidden = true;
        } else {
          variantsEl.hidden = false;
          variants.forEach(function (v, idx) {
            variantsEl.appendChild(buildVariantRow(v, idx));
          });
        }
      }

      if (bisMode) {
        if (variants.length) setBisVariant(variants[0].id);
        openDialog(dialog);
        return;
      }

      if (variants.length) {
        if (totalEl) totalEl.textContent = formatPrice(discountedCents(variants[0].price));
        if (submitEl) submitEl.disabled = !variants[0].available;
      } else {
        if (totalEl) totalEl.textContent = "-";
        if (submitEl) submitEl.disabled = true;
      }

      openDialog(dialog);
    }

    on(root, "click", function (e) {
      var trigger = e.target.closest("[data-zeus-pg-reserve-open]");
      if (!trigger) return;
      e.preventDefault();
      var card = trigger.closest("[data-zeus-pg-card]");
      if (card) hydrate(card);
    });

    if (closeBtn)
      closeBtn.addEventListener("click", function () {
        closeDialog(dialog);
      });
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog) closeDialog(dialog);
    });
    dialog.addEventListener("cancel", function () {
      document.body.removeAttribute("data-zeus-pg-modal-open");
    });

    // Intercept submit: POST to /cart/add.js (AJAX), close modal, open cart drawer.
    if (formEl) {
      formEl.addEventListener("submit", function (ev) {
        ev.preventDefault();
        if (!formIdEl || !formIdEl.value) return;
        if (submitEl) {
          submitEl.disabled = true;
          submitEl.setAttribute("data-loading", "1");
        }
        var fd = new FormData(formEl);
        var cartAddUrl = window.Shopify?.routes?.root
          ? window.Shopify.routes.root + "cart/add.js"
          : window.routes?.cart_add_url
            ? window.routes.cart_add_url + ".js"
            : "/cart/add.js";
        fetch(cartAddUrl, {
          method: "POST",
          headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: fd,
        })
          .then(function (res) {
            if (!res.ok)
              return res.json().then(function (err) {
                throw err;
              });
            return res.json();
          })
          .then(function () {
            closeDialog(dialog);
            var cartJsUrl = window.Shopify?.routes?.root ? window.Shopify.routes.root + "cart.js" : "/cart.js";
            return fetch(cartJsUrl, { headers: { Accept: "application/json" } })
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                // Notify any listener (cart-count web component, custom theme JS, etc.)
                document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent("cart:items-changed", { detail: { cart: cart } }));
                document.dispatchEvent(new CustomEvent("cart:add", { detail: { cart: cart } }));

                // Open the cart drawer. Order: native web-component method, then trigger the header link.
                var drawer = document.getElementById("cart-drawer") || document.querySelector("cart-drawer");
                if (drawer && typeof drawer.open === "function") {
                  drawer.open();
                  return;
                }
                if (drawer && typeof drawer.show === "function") {
                  drawer.show();
                  return;
                }
                var ariaTrigger = document.querySelector('[aria-controls="cart-drawer"]');
                if (ariaTrigger) {
                  ariaTrigger.click();
                  return;
                }
                // Last resort: navigate to cart page
                window.location.href = (window.routes && window.routes.cart_url) || "/cart";
              });
          })
          .catch(function (err) {
            console.error("[zeus-preorder] cart add failed", err);
            var msg =
              (err && err.description) ||
              (err && err.message) ||
              root.getAttribute("data-cart-error") ||
              "Could not add to cart.";
            alert(msg);
          })
          .finally(function () {
            if (submitEl) {
              submitEl.disabled = false;
              submitEl.removeAttribute("data-loading");
            }
          });
      });
    }
  }

  /* ========================================================= */
  /* SPECS MODAL                                               */
  /* ========================================================= */
  function initSpecsModal() {
    var dialog = root.querySelector("[data-zeus-pg-specs-modal]");
    if (!dialog) return;

    var titleEl = dialog.querySelector("[data-zeus-pg-sm-title]");
    var tagEl = dialog.querySelector("[data-zeus-pg-sm-tag]");
    var volEl = dialog.querySelector("[data-zeus-pg-sm-vol]");
    var lenEl = dialog.querySelector("[data-zeus-pg-sm-len]");
    var weightEl = dialog.querySelector("[data-zeus-pg-sm-weight]");
    var descEl = dialog.querySelector("[data-zeus-pg-sm-desc]");
    var reserveBtn = dialog.querySelector("[data-zeus-pg-sm-reserve]");
    var reserveLabel = reserveBtn ? reserveBtn.textContent : "";
    var closeBtn = dialog.querySelector("[data-zeus-pg-specs-close]");

    function applyVal(el, val) {
      if (!el) return;
      if (val && String(val).trim() !== "") {
        el.textContent = val;
        el.removeAttribute("data-empty");
        var parent = el.closest(".zeus-pg-specs-cell");
        if (parent) parent.style.display = "";
      } else {
        el.textContent = "";
        el.setAttribute("data-empty", "1");
        var parent = el.closest(".zeus-pg-specs-cell");
        if (parent) parent.style.display = "none";
      }
    }

    on(root, "click", function (e) {
      var trigger = e.target.closest("[data-zeus-pg-specs-open]");
      if (!trigger) return;
      e.preventDefault();
      var card = trigger.closest("[data-zeus-pg-card]");
      if (!card) return;

      applyVal(titleEl, card.getAttribute("data-product-title"));
      applyVal(tagEl, card.getAttribute("data-product-tag"));
      applyVal(volEl, card.getAttribute("data-spec-volume"));
      applyVal(lenEl, card.getAttribute("data-spec-length"));
      applyVal(weightEl, card.getAttribute("data-spec-weight-max"));
      applyVal(descEl, card.getAttribute("data-product-desc"));

      if (reserveBtn) {
        var preorderSubmit = card.querySelector("[data-zeus-pg-preorder-submit]");
        reserveBtn.textContent = preorderSubmit ? preorderSubmit.textContent.trim() : reserveLabel;
        reserveBtn.onclick = function (ev) {
          ev.preventDefault();
          closeDialog(dialog);
          setTimeout(function () {
            var openBtn = card.querySelector("[data-zeus-pg-reserve-open]");
            if (openBtn) openBtn.click();
            else {
              var preorderBtn = card.querySelector("[data-zeus-pg-preorder-submit]");
              if (preorderBtn) preorderBtn.focus();
            }
          }, 100);
        };
      }

      openDialog(dialog);
    });

    if (closeBtn)
      closeBtn.addEventListener("click", function () {
        closeDialog(dialog);
      });
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog) closeDialog(dialog);
    });
    dialog.addEventListener("cancel", function () {
      document.body.removeAttribute("data-zeus-pg-modal-open");
    });
  }

  /* ========================================================= */
  /* BOOT                                                      */
  /* ========================================================= */
  function boot() {
    initSectionNav();
    initCountdown();
    initReservedCounter();
    initReserveModal();
    initSpecsModal();
  }

  if (document.readyState === "loading") {
    on(document, "DOMContentLoaded", boot);
  } else {
    boot();
  }

  on(document, "shopify:section:unload", function (event) {
    if (event.target.contains(root) && window.__zeusPrecommandeCleanup) {
      window.__zeusPrecommandeCleanup();
    }
  });
})();
